import { z } from 'zod';
import type { TranslationKey } from '../i18n/types';

export const STORE_NAME_MAX_LENGTH = 100;
export const STORE_DESCRIPTION_MAX_LENGTH = 500;

export interface StoreDetailsSchemaKeys {
  readonly nameRequired: TranslationKey;
  readonly nameTooLong: TranslationKey;
  readonly descriptionRequired: TranslationKey;
  readonly descriptionTooLong: TranslationKey;
}

export function makeStoreDetailsSchema(keys: StoreDetailsSchemaKeys): z.ZodObject<{
  name: z.ZodString;
  description: z.ZodString;
}> {
  return z.object({
    name: z
      .string()
      .trim()
      .min(1, { message: keys.nameRequired })
      .max(STORE_NAME_MAX_LENGTH, { message: keys.nameTooLong }),
    description: z
      .string()
      .trim()
      .min(1, { message: keys.descriptionRequired })
      .max(STORE_DESCRIPTION_MAX_LENGTH, { message: keys.descriptionTooLong }),
  });
}

export const createStoreDetailsSchema = makeStoreDetailsSchema({
  nameRequired: 'admin.createStore.errors.nameRequired',
  nameTooLong: 'admin.createStore.errors.nameTooLong',
  descriptionRequired: 'admin.createStore.errors.descriptionRequired',
  descriptionTooLong: 'admin.createStore.errors.descriptionTooLong',
});

export const updateStoreDetailsSchema = makeStoreDetailsSchema({
  nameRequired: 'admin.storeSettings.errors.nameRequired',
  nameTooLong: 'admin.storeSettings.errors.nameTooLong',
  descriptionRequired: 'admin.storeSettings.errors.descriptionRequired',
  descriptionTooLong: 'admin.storeSettings.errors.descriptionTooLong',
}).extend({
  localityId: z.string().uuid({ message: 'admin.storeSettings.errors.localityRequired' }),
});

export type StoreDetailsFormValues = z.infer<typeof updateStoreDetailsSchema>;
